<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>设备管理</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-row>
				<el-col :span="18">
					<el-form :inline="true">
						<el-form-item label="车间选择">
							<WorkshopSelect v-model="workshopId" />
						</el-form-item>
						<el-form-item>
							<el-button type="info" icon="el-icon-search" @click="onSubmit">查询</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="6" style="text-align:right;">
					<el-button type="primary" icon="el-icon-plus" @click="add">新增设备</el-button>
				</el-col>
			</el-row>
		</div>

		<!--设备列表-->
		<el-table border v-loading="tableLoading" :data="tableData">
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column label="所在车间" width="160">
				<template slot-scope="scope">
					<div v-text="getWorkshopName(scope.row.workshop_id)"></div>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="机台名称"></el-table-column>
			<el-table-column prop="type" label="机台类型" width="100">
				<template slot-scope="scope">
					<span v-text="getDeviceTypeName(scope.row)"></span>
				</template>
			</el-table-column>
			<el-table-column prop="code" label="机台编号" width="100"></el-table-column>
			<el-table-column prop="width" label="机台幅宽" width="90"></el-table-column>
			<el-table-column prop="material_len" label="物料长度" width="90"></el-table-column>
			<el-table-column prop="pre_time" label="准备时间" width="100"></el-table-column>
			<el-table-column prop="yield_rate" label="良率" width="70"></el-table-column>
			<el-table-column prop="day_time" label="白班开始时间" width="120"> </el-table-column>
			<el-table-column prop="night_time" label="晚班开始时间" width="120"></el-table-column>
			<el-table-column label="工艺参数" width="200">
				<template slot-scope="scope">
					<span style="margin-right:20px; display:inline-block; width:100px; " v-text="formatTeachGroupName(scope.row.tech_group_name)"></span>
					<span v-show="scope.row.tech_group_name">
						<el-button @click="showTeachGroupDetailDialog(scope.row)" type="text" icon="el-icon-view">查看</el-button>
						<el-divider direction="vertical"></el-divider>
					</span>
					<el-button @click="showTeachGroupDialog(scope.row)" type="text" icon="el-icon-edit">设置</el-button>
				</template>
			</el-table-column>
			<el-table-column label="编辑" width="160">
				<template slot-scope="scope">
					<el-button type="text" icon="el-icon-edit" @click="edit(scope.row)">编辑</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-popconfirm title="删除可能造成数据紊乱,确定删除吗？" @onConfirm="showDelete(scope.row)">
						<el-button type="text" icon="el-icon-delete" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination layout="sizes, prev, pager, next, total" :page-count="pageCount" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="currentChange" @size-change="sizeChange"> </el-pagination>

		<!-- 编辑机台信息  -->
		<el-dialog :title="formDialogTitle" :visible.sync="formDialogVisable" width="600px">
			<device-edit v-model="deviceInfo" ref="deviceForm"></device-edit>
			<div slot="footer" class="dialog-footer">
				<el-button @click="formDialogVisable = false">取消</el-button>
				<el-button type="primary" :loading="saving" v-on:click="save">保存</el-button>
			</div>
		</el-dialog>

		<TeachGroupDialog :show="teachGroupDialogVisible" v-on:close="teachGroupDialogClose" v-on:setTeachGroup="setTeachGroup" />
		<TeachGroupDetailDialog :show="teachGroupDetailDialogVisible" :teachGroupId="selectedTeachGroupId" v-on:close="detailDialogClose" />
	</div>
</template>

<script>
	import WorkshopSelect from '@/components/WorkshopSelect'
	import jtRequest, { jtInfoRequest } from '@/network/requests/jtInfo'
	import DeviceEdit from './DeviceEdit'
	import deviceType from '../../public/DeviceType'
	import { workshopRequest } from '@/network/requests/workshop'
	import TeachGroupDialog from '../../public/TeachGroupDialog'
	import TeachGroupDetailDialog from '../../public/TeachGroupDetailDialog'
	import { jtStatusRequest } from '@/network/requests/jtStatus'
	export default {
		components: {
			WorkshopSelect,
			DeviceEdit,
			TeachGroupDialog,
			TeachGroupDetailDialog,
		},
		data() {
			return {
				tableData: [],
				tableLoading: false,
				deviceInfo: {},
				currentDeviceId: '',
				formLabelWidth: '120px',
				formDialogVisable: false,
				workshopId: '',
				formDialogTitle: '',
				workshops: [],
				teachGroupDialogVisible: false,
				teachGroupDetailDialogVisible: false,
				selectedTeachGroupId: '',
				pageCount: 1,
				pageSize: 10,
				pageIndex: 1,
				saving: false,
			}
		},
		watch: {
			/**
			 * 车间Id。
			 */
			workshopId(val) {
				console.log(val)
			},
		},
		methods: {
			/**
			 * 查询
			 */
			onSubmit() {
				this.pageIndex = 1
				this.tableLoading = true
				this.query()
			},
			/**
			 * 新增机台
			 */
			add() {
				this.deviceInfo = {}
				this.formDialogVisable = true
				this.formDialogTitle = '新增机台信息'
			},
			/**
			 * 编辑机台
			 */
			edit(row) {
				this.formDialogVisable = true
				this.formDialogTitle = '机台信息编辑'
				this.deviceInfo = { ...row }
			},
			showDelete(row) {
				jtInfoRequest
					.deleteById(row._id.$oid)
					.then(res => {
						this.query()
						this.$message({
							type: 'success',
							message: '删成功',
						})
					})
					.catch(error => {
						this.$message({
							type: 'error',
							message: error.message,
						})
					})
			},
			/**
			 * 保存机台编辑
			 */
			save() {
				if (this.saving) {
					return
				} else {
					this.saving = true
				}
				this.$refs.deviceForm.validate(valid => {
					console.log('valid', valid)
					if (valid) {
						this.tableLoading = true
						jtRequest
							.save(this.deviceInfo)
							.then(res => {
								console.log('this.deviceInfo', this.deviceInfo)
								console.log('保存机台结果', res)
								//如果是新增机台，这里需要增加关联的机台的默认状态。
								if (!this.deviceInfo._id) {
									var jtStatusInfo = {
										jt_id: res,
										status: 0,
										status_icw: 0,
										count: 0,
										roll_id: '',
										criterial_level_file_id: '',
										rule_info_file_id: '',
										defect_level_file_id: '',
										errors: '',
										is_have_error: 0,
									}
									jtStatusRequest.upload(jtStatusInfo)
								}
							})
							.finally(() => {
								this.formDialogVisable = false

								setTimeout(() => {
									this.saving = false
								}, 1000)

								this.pageIndex = 1
								this.query()
							})
					} else {
						this.saving = false
					}
				})
			},
			/**
			 * 获取车间所有机台。
			 */
			query() {
				jtInfoRequest.searchPage(this.pageSize, this.pageIndex, { workshop_id: this.workshopId }).then(res => {
					this.tableData = res.data._embedded
					this.pageCount = res.data._total_pages
					this.tableLoading = false
				})
			},
			/**
			 * 获取设备类型。
			 */
			getDeviceTypeName(row) {
				return deviceType.getName(row.type)
			},
			/**
			 * 获取车间名称。
			 */
			getWorkshopName(id) {
				var first = this.workshops.find(t => t._id.$oid == id)
				if (first) {
					return first.name
				}

				return ''
			},
			/**
			 * 弹出工艺参数组设置。
			 */
			showTeachGroupDialog(row) {
				this.currentDeviceId = row._id.$oid
				this.teachGroupDialogVisible = true
			},
			/**
			 * 弹出工艺参数信息。
			 */
			showTeachGroupDetailDialog(row) {
				this.currentDeviceId = row._id.$oid
				this.selectedTeachGroupId = row.tech_group_id
				this.teachGroupDetailDialogVisible = true
			},
			/**
			 * 设置工艺参数组。
			 */
			setTeachGroup(teachGroupInfo) {
				jtRequest.setTeachGroup(this.currentDeviceId, teachGroupInfo.id, teachGroupInfo.name).then(res => {
					if (res.status == 200) {
						//重新加载产品列表。
						this.query()
					}
				})
			},
			/**
			 * 格式化工艺参数组名称。
			 */
			formatTeachGroupName(name) {
				if (name) {
					return name
				}

				return '未设置'
			},
			/**
			 * 关闭参数详情弹出框。
			 */
			detailDialogClose() {
				this.teachGroupDetailDialogVisible = false
			},
			/**
			 * 关闭参数组选择框。
			 */
			teachGroupDialogClose() {
				this.teachGroupDialogVisible = false
			},
			/**
			 * 查看当前页码。
			 */
			currentChange(page) {
				this.tableLoading = true
				this.pageIndex = page
				this.query()
			},
			/**
			 * 切换页码。
			 */
			sizeChange(size) {
				this.tableLoading = true
				this.pageSize = size
				this.pageIndex = 1
				this.query()
			},
		},
		created() {
			//加载提示
			this.tableLoading = true

			//获取所有车间。
			workshopRequest
				.queryAll()
				.then(res => {
					this.workshops = res
				})
				.finally(() => {
					this.query()
				})
		},
	}
</script>
